<template>
    <div class="all">
        <div class="container">
            <div class="grid-father">
                <div class="grid h-auto">
                    <div class="grid-body">
                        <div class="ac">
                            <h2 class="compet-tit" v-html="title">{{title}}</h2>
                            <p class="mt10 cr52">{{times}}</p>
                            <table class="table compet-table al cr52 mt30" width="100%" border="0" cellpadding="0" cellspacing="0">
                                <colgroup>
                                    <col width="45%">
                                    <col width="15%">
                                    <col width="40%">
                                </colgroup>
                                <thead>
                                    <tr class="bged">
                                        <th>方案名称</th>
                                        <th>数据总量</th>
                                        <th class="ar">分析词组</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in competTotalList" :key="index">
                                        <td>{{item.name}}</td>
                                        <td>{{item.num}}</td>
                                        <td class="ar">{{keyWordsFilter(item.keywords)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-father mt20">
                <div class="grid h-auto">
                    <div class="grid-header clearfix"><h2 class="title">趋势对比</h2></div> 
                    <div class="grid-body mt15">
                        <div class="echart-warp h340">
                            <lineChart id="lineEchart" :dataArray="lineChartData" v-if="lineChartData !=''" :isShowArea="false" :colorArr="lineColor"></lineChart>
                        </div>
                        <p class="mt15 cr52" v-html="trendHtml">{{trendHtml}}</p>  
                        <!-- <p class="mt15 cr52">{{从综合指数变化趋势来看,【联想5G】的热度在在09/10达到了<strong class="cr09">4678</strong>的峰值。从综合指数变化趋势来看,【北京电影学院现代创意媒体学院】的热度在在09/08达到了3000的峰值。从综合指数变化趋势来看,【上海戏剧学院】的热度在在09/11达到了4560的峰值}}。</p> -->
                    </div>
                </div>
            </div>
            <div class="grid-father mt20">
                <div class="grid h-auto">
                    <div class="grid-header clearfix"><h2 class="title">平台分布</h2></div> 
                    <div class="grid-body mt15">
                        <div class="echart-warp h340">
                            <barChart id="barEchart" :dataArray="barChartData" v-if="barChartData !=''" :colorArr="lineColor" barWidth="26%"></barChart>
                        </div>  
                        <p class="mt15 cr52" v-html="platHtml">{{platHtml}}</p>
                    </div>
                </div>
            </div>
            <div class="grid-father mt20">
                <div class="grid h-auto">
                    <div class="grid-header clearfix"><h2 class="title">情感分布</h2></div> 
                    <div class="grid-body mt15">
                        <div class="echart-warp compet-wrap clearfix">
                            <div class="compet-li fl" :class="caseNum==2?'md5':'md3'" v-for="(item,index) in pieChartData.data" :key="index">
                                <div class="ac">【{{caseName[index].name}}】</div>
                                <div class="h280">
                                    <pieChart :id="'pieChart'+index" :dataArray="item.data" v-if="item.data != ''" :colorArr="pieColorArr" :showLegend="false" :isLabelbr="true"></pieChart>
                                </div>
                            </div>
                        </div>   
                        <p class="mt15 cr52" v-html="pieChartData.html">{{pieChartData.html}}</p>
                    </div>
                </div>
            </div>
            <div class="grid-father mt20">
                <div class="grid h-auto">
                    <div class="grid-header clearfix"><h2 class="title">热门主题词</h2></div> 
                    <div class="grid-body mt15">
                        <div class="echart-warp compet-wrap clearfix">
                            <div class="compet-li fl " :class="caseNum==2?'md5':'md3'" v-for="(item,index) in defaultWords.data" :key="index">
                                <div class="ac">【{{caseName[index].name}}】</div>
                                <div class="h280">
                                    <cloudChart :id="'wordCloud'+index" :dataArray="item.hotwords" cuozu="45px"></cloudChart>
                                </div>
                            </div>
                        </div>   
                        <p class="mt15 cr52" v-html="defaultWords.html">{{defaultWords.html}}</p>
                    </div>
                </div>
            </div>
            <div class="grid-father mt20">
                <div class="grid h-auto">
                    <div class="grid-header clearfix"><h2 class="title">发布地区</h2></div> 
                    <div class="grid-body mt15">
                        <div class="echart-warp compet-wrap clearfix">
                             <div class="compet-li fl " :class="caseNum==2?'md5':'md3'" v-for="(item,index) in mapChartData.data" :key="index">
                                <div class="ac">【{{caseName[index].name}}】</div>
                                <div class="h280">
                                    <mapChart :id="'mapEchart'+index" :dataArray="item.province" :areaName="curMapName" v-if="item != ''"></mapChart>
                                </div>
                                <ul class="competMap ac clearfix">
                                    <li class="item" v-for="(item1,index1) in item.province.slice(0,10)" :key="index1">
                                        <p class="bged">{{item1.name}}</p>
                                        <p>{{item1.value}}</p>
                                    </li>
                                </ul>
                                
                            </div>
                        </div>   
                        <p class="mt15 cr52">{{mapChartData.html}}</p>
                    </div>
                </div>
            </div>
            <div class="grid-father mt20">
                <div class="grid h-auto">
                    <div class="grid-header clearfix"><h2 class="title">活跃账号</h2></div> 
                    <div class="grid-body mt15">
                        <div class="echart-warp compet-wrap clearfix">
                            <div class="compet-li fl" :class="caseNum==2?'md5':'md3'" v-for="(item,index) of activeAccList.data" :key="index">
                                <div class="ac">【{{index}}】</div>
                                <ul class="strip-shape mt10">
                                    <li class="cp" v-for="(item1,index1) of item" :key="index1">
                                        <span>{{item1.name}}</span>
                                        <div class="mt-8 clearfix">
                                            <div class="number fr">
                                                <strong class="color-blue">{{item1.value}}</strong>
                                            </div>
                                            <div class="line-warp clearfix">
                                                <div class="line">
                                                    <div class="in" :style="{width:+item1.percent+'%'}"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>  
                        <p class="mt15 cr52">{{activeAccList.html}}</p>
                    </div>
                </div>
            </div>
            <div class="grid-father mt20">
                <div class="grid h-auto">
                    <div class="grid-header clearfix"><h2 class="title">热点文章</h2></div> 
                    <div class="grid-body mt15">
                        <div class="echart-warp compet-wrap clearfix">
                            <div class="compet-li fl" :class="caseNum==2?'md5':'md3'" v-for="(item,index) of hotArtList.data" :key="index">
                                <div class="ac">【{{index}}】</div>
                                <table class="table al cr52 mt10" width="100%" border="0" cellpadding="0" cellspacing="0">
                                    <colgroup>
                                        <col />
                                        <col width="22%"/>
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>标题</th>
                                            <th class="ar">相似文章数</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item1,index1) of item" :key="index1">
                                            <td><a class="ovhidden cr52" :href="item1.newsInfo.news_url" target="_blank">{{item1.newsInfo.news_title}}</a></td>
                                            <td class="ar">{{item1.numFound}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import lineChart from '../../components/echart/lineChart.vue';
import pieChart from '../../components/echart/pieChart.vue';
import barChart from '../../components/echart/barChart.vue';
import mapChart from '../../components/echart/mapChart.vue';
import cloudChart from '../../components/echart/wordCloud.vue';
export default {
    components:{lineChart,pieChart,barChart,cloudChart,mapChart},
    data() {
        return {
            sid:this.$route.query.id,
            title:'',//标题
            times:'',//时间
            caseName:'',//方案名称
            caseNum:'',//方案个数
            competTotalList:'',//分析词对比
            lineChartData:[],//趋势对比
            trendHtml:'',//趋势对比文章
            barChartData:[],//平台分布
            platHtml:[],//平台分布文章
            lineColor:["#2475fb","#e52e45","#f99074"],
            pieChartData:[],//情感分布
            pieColorArr:["#2475fb","#e52e45","#ff8121"], 
            defaultWords:[],//热门主题词 
            mapChartData:[], //发布地区
            mapList:[], //发布地区
            curMapName:'全国',
            activeAccList:[],//活跃账号
            hotArtList:[],//热点文章
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.dataAjax();
        }) 
    },
    methods: {
        dataAjax(){
            let that = this;
            
            that.$api.get('monitor/compare/compare-info', {id:that.sid}, r => {
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.title = data.header;
                    that.times = data.times;
                    that.caseNum = data.count;
                    that.caseName = data.schemes;
                    that.competTotalList = JSON.parse(data.total);
                    //趋势对比
                    let trendData= JSON.parse(data.trend);
                    that.lineChartData = {
                        "dataName":trendData.legend,
                        "datetime":trendData.datetime_seq
                    };
                    for(var i in trendData.Y) {
                        that.lineChartData[i] = trendData.Y[i];
                    }
                    that.trendHtml = trendData.html;
                     // 平台分布
                    let platData = JSON.parse(data.platforms);
                    let platValArr = [];
                    for(var i in platData.data) {
                        platValArr.push(platData.data[i])
                    }
                    that.barChartData = {
                        "datetime":platData.dataYaxis,
                        "dataName":platData.legend,
                        "data":platValArr
                    }
                    that.platHtml = platData.html;
                    // 情感属性
                    that.pieChartData = JSON.parse(data.emotions);
                    // 热门主题词
                    that.defaultWords = JSON.parse(data.hotWords);
                     //发布地区
                    that.mapChartData = JSON.parse(data.publishArea);
                    // 活跃账号
                    that.activeAccList = JSON.parse(data.activeAccounts);
                    // 热点文章
                    that.hotArtList = JSON.parse(data.hotArticles);
                    // console.log(that.hotArtList);
                });
            })
        },
        
        keyWordsFilter(val){
            let newVal = val.join('+'); 
            return newVal;
        }
    }
   
}
</script>



// WEBPACK FOOTER //
// src/page/competingReports/competDetail.vue